var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28951 6.70978C9.19681 6.80229 9.12326 6.91218 9.07308 7.03315C9.0229 7.15413 8.99707 7.28381 8.99707 7.41478C8.99707 7.54575 9.0229 7.67543 9.07308 7.7964C9.12326 7.91738 9.19681 8.02726 9.28951 8.11978L13.1695 11.9998L9.28951 15.8798C9.19693 15.9724 9.12349 16.0823 9.07339 16.2032C9.02328 16.3242 8.99749 16.4538 8.99749 16.5848C8.99749 16.7157 9.02328 16.8454 9.07339 16.9663C9.12349 17.0873 9.19693 17.1972 9.28951 17.2898C9.3821 17.3824 9.49201 17.4558 9.61297 17.5059C9.73394 17.556 9.86358 17.5818 9.99451 17.5818C10.1254 17.5818 10.2551 17.556 10.3761 17.5059C10.497 17.4558 10.6069 17.3824 10.6995 17.2898L15.2895 12.6998C15.3822 12.6073 15.4558 12.4974 15.5059 12.3764C15.5561 12.2554 15.582 12.1257 15.582 11.9948C15.582 11.8638 15.5561 11.7341 15.5059 11.6132C15.4558 11.4922 15.3822 11.3823 15.2895 11.2898L10.6995 6.69978C10.3195 6.31978 9.67951 6.31978 9.28951 6.70978Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.ffb2aec45da6bebb61a83b20d7c28021.svg";
export { ForwardRef as ReactComponent };